module.exports = __webpack_public_path__ + "img/zhu_yj_quxiuli.687a0da5.jpg";